/* Auto-select first available Farve (option2) when Finish (option1) changes.
   Works with Shopify radio swatches that use `data-option-position` and `form` attrs. */

   (function () {
    function getFarvePosition(formId, root) {
      const rootEl = root || document;
      const picker = rootEl.querySelector(`variant-picker[form-id="${formId}"]`);
  
      if (picker) {
        const fieldsets = picker.querySelectorAll('fieldset.variant-picker__option');
  
        for (const fs of fieldsets) {
          const legend = fs.querySelector('legend');
          if (!legend) continue;
  
          const text = legend.textContent.trim().toLowerCase();
  
          if (text.includes('farve') || text.includes('color') || text.includes('colour')) {
            const input = fs.querySelector(
              `input[type="radio"][data-option-position][form="${formId}"]`
            );
  
            if (input) {
              return input.getAttribute('data-option-position');
            }
          }
        }
      }
  
      // Fallback: assume Farve is option 2 if we cannot detect it.
      return '2';
    }
  
    function getLabel(input, root) {
      // Most themes have <input> immediately followed by its <label>
      const sib = input.nextElementSibling;
      if (sib && sib.tagName === 'LABEL') return sib;
      // Fallback (in case markup differs)
      return (root || document).querySelector(`label[for="${input.id}"]`);
    }
  
    function isColorUsable(input, root) {
      if (!input || input.disabled) return false;
      const label = getLabel(input, root);
      return !!label && !label.classList.contains('is-disabled');
    }
  
    function currentColorValid(formId, root) {
      const pos = getFarvePosition(formId, root);
      const cur = (root || document).querySelector(
        `input[type="radio"][data-option-position="${pos}"][form="${formId}"]:checked`
      );
      return isColorUsable(cur, root);
    }
  
    function firstUsableColor(formId, root) {
      const pos = getFarvePosition(formId, root);
      const list = Array.from((root || document).querySelectorAll(
        `input[type="radio"][data-option-position="${pos}"][form="${formId}"]`
      ));
      return list.find((i) => isColorUsable(i, root));
    }
  
    function normalizeFarve(formId, root) {
      // If current color is fine, do nothing.
      if (currentColorValid(formId, root)) return;
  
      const cand = firstUsableColor(formId, root);
      if (cand && !cand.checked) {
        cand.checked = true;
        // Let the theme handle the rest
        cand.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  
    // When FINISH (option1) changes, normalize Farve after the theme toggles classes.
    document.addEventListener('change', (e) => {
      const el = e.target;
      if (!el.matches('input[type="radio"][data-option-position="1"]')) return;
  
      const formId = el.getAttribute('form');
      if (!formId) return;
  
      // Wait a tick so `.is-disabled`/disabled states are correct
      setTimeout(() => normalizeFarve(formId, document), 0);
    });
  
    // Fix initial state on load (e.g., a disabled Farve is preselected)
    window.addEventListener('load', () => {
      const forms = new Set(
        Array.from(document.querySelectorAll('input[type="radio"][data-option-position="2"]'))
          .map((i) => i.getAttribute('form'))
          .filter(Boolean)
      );
      forms.forEach((formId) => normalizeFarve(formId, document));
    });
  
  })();
  